import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import store from "@/store";
import { Loading, Pagination,Image } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(Pagination);
Vue.use(Loading);
Vue.use(Image);
Vue.config.productionTip = false;
Vue.L = Vue.prototype.$L = L;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
